$(document).ready(function(){
		  
		  $("#animpm01").hover(function () {    
	          $("#animal-pm01")
	             .addClass("activo");  //Add the active class to the area is hovered
	      }, function () {
	          $("#animal-pm01")
	             .removeClass("activo");
	      });

	      $("#animpm02").hover(function () {    
	          $("#animal-pm02")
	             .addClass("activo");  //Add the active class to the area is hovered
	      }, function () {
	          $("#animal-pm02")
	             .removeClass("activo");
	      }); 
	      $("#animpm03").hover(function () {    
	          $("#animal-pm03")
	             .addClass("activo");  //Add the active class to the area is hovered
	      }, function () {
	          $("#animal-pm03")
	             .removeClass("activo");
	      });
	      $("#animpm04").hover(function () {    
	          $("#animal-pm04")
	             .addClass("activo");  //Add the active class to the area is hovered
	      }, function () {
	          $("#animal-pm04")
	             .removeClass("activo");
	      });
	      $("#animpm05").hover(function () {    
	          $("#animal-pm05")
	             .addClass("activo");  //Add the active class to the area is hovered
	      }, function () {
	          $("#animal-pm05")
	             .removeClass("activo");
	      });
	      $("#animpm06").hover(function () {    
	          $("#animal-pm06")
	             .addClass("activo");  //Add the active class to the area is hovered
	      }, function () {
	          $("#animal-pm06")
	             .removeClass("activo");
	      });
	      $("#animpm07").hover(function () {    
	          $("#animal-pm07")
	             .addClass("activo");  //Add the active class to the area is hovered
	      }, function () {
	          $("#animal-pm07")
	             .removeClass("activo");
	      });
	      $("#animpm08").hover(function () {    
	          $("#animal-pm08")
	             .addClass("activo");  //Add the active class to the area is hovered
	      }, function () {
	          $("#animal-pm08")
	             .removeClass("activo");
	      });
	      $("#animpm09").hover(function () {    
	          $("#animal-pm09")
	             .addClass("activo");  //Add the active class to the area is hovered
	      }, function () {
	          $("#animal-pm09")
	             .removeClass("activo");
	      });
	      $("#animpm10").hover(function () {    
	          $("#animal-pm10")
	             .addClass("activo");  //Add the active class to the area is hovered
	      }, function () {
	          $("#animal-pm10")
	             .removeClass("activo");
	      });   
		});